import { createStore } from 'vuex'
import getters from './getters'
import user from './modules/user'
import global from './modules/global'


export default createStore({
    getters,
    modules: {
        user,
        global,
    },
})
